"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationList = exports.Notification = exports.NotificationDeletePayload = exports.NotificationUpdatePayload = exports.NotificationCreatePayload = exports.ChannelDeletePayload = exports.SmsChannelUpdatePayload = exports.SmsChannelCreatePayload = exports.EmailChannelUpdatePayload = exports.EmailChannelCreatePayload = exports.MobileChannelUpdatePayload = exports.MobileChannelCreatePayload = exports.ChannelList = exports.Channel = exports.NAMESPACE = exports.ChannelCreateResult = void 0;
const effect_1 = require("effect");
const Json = __importStar(require("../../../../../json"));
const field_1 = require("../../../openapi/field");
const notification_1 = require("../../shared/notification");
const notification_fields_1 = require("../../shared/notification-fields");
var notification_2 = require("../../shared/notification");
Object.defineProperty(exports, "ChannelCreateResult", { enumerable: true, get: function () { return notification_2.ChannelCreateResult; } });
exports.NAMESPACE = 'Culligan.Api.V1.Frontend.Notification.Schema';
const channelOwnerRule = 'The channel must belong to the caller and to the client application of the current session; otherwise the answer is 401';
const channelCommon = {
    ...notification_fields_1.channelKey,
    ...notification_fields_1.channelBase,
    editable: effect_1.Schema.Boolean.annotations({
        description: 'true when the channel was created by the client application of the current session',
    }),
};
const MobileChannel = effect_1.Schema.Struct({ ...channelCommon, ...notification_fields_1.mobileChannelBody });
const EmailChannel = effect_1.Schema.Struct({ ...channelCommon, ...notification_fields_1.emailChannelBody });
const SmsChannel = effect_1.Schema.Struct({ ...channelCommon, ...notification_fields_1.smsChannelBody });
/** Webhook channels are listed too, even though this router cannot create them. */
const OtherChannel = effect_1.Schema.Struct({ ...channelCommon, ...notification_fields_1.webhookChannelBody }).pipe(effect_1.Schema.extend(effect_1.Schema.Record({ key: effect_1.Schema.String, value: Json.Value })));
exports.Channel = effect_1.Schema.Union(MobileChannel, EmailChannel, SmsChannel, OtherChannel).annotations({
    identifier: `${exports.NAMESPACE}.Channel`,
    description: 'Notification channel of the signed-in user, without the owner and client app ids',
});
exports.ChannelList = effect_1.Schema.Struct({
    channels: effect_1.Schema.Array(exports.Channel),
}).annotations({
    identifier: `${exports.NAMESPACE}.ChannelList`,
});
exports.MobileChannelCreatePayload = effect_1.Schema.Struct({
    ...notification_fields_1.mobileChannelPayloadFields,
}).annotations({
    identifier: `${exports.NAMESPACE}.MobileChannelCreatePayload`,
    description: 'The owner and the client application are taken from the session, not from the body',
});
exports.MobileChannelUpdatePayload = effect_1.Schema.Struct({
    channelId: (0, field_1.nonEmpty)('Notification channel id'),
    ...exports.MobileChannelCreatePayload.fields,
}).annotations({
    identifier: `${exports.NAMESPACE}.MobileChannelUpdatePayload`,
    description: channelOwnerRule,
});
exports.EmailChannelCreatePayload = effect_1.Schema.Struct({
    ...notification_fields_1.emailChannelPayloadFields,
}).annotations({
    identifier: `${exports.NAMESPACE}.EmailChannelCreatePayload`,
    description: 'The owner and the client application are taken from the session, not from the body',
});
exports.EmailChannelUpdatePayload = effect_1.Schema.Struct({
    channelId: (0, field_1.nonEmpty)('Notification channel id'),
    ...exports.EmailChannelCreatePayload.fields,
}).annotations({
    identifier: `${exports.NAMESPACE}.EmailChannelUpdatePayload`,
    description: channelOwnerRule,
});
exports.SmsChannelCreatePayload = effect_1.Schema.Struct({
    ...notification_fields_1.smsChannelPayloadFields,
}).annotations({
    identifier: `${exports.NAMESPACE}.SmsChannelCreatePayload`,
    description: 'The owner and the client application are taken from the session, not from the body',
});
exports.SmsChannelUpdatePayload = effect_1.Schema.Struct({
    channelId: (0, field_1.nonEmpty)('Notification channel id'),
    ...exports.SmsChannelCreatePayload.fields,
}).annotations({
    identifier: `${exports.NAMESPACE}.SmsChannelUpdatePayload`,
    description: channelOwnerRule,
});
exports.ChannelDeletePayload = effect_1.Schema.Struct({
    channelId: (0, field_1.nonEmpty)('Notification channel id'),
}).annotations({
    identifier: `${exports.NAMESPACE}.ChannelDeletePayload`,
    description: channelOwnerRule,
});
const rulePayload = {
    ...notification_fields_1.rulePayloadFields,
    channelIds: effect_1.Schema.propertySignature(effect_1.Schema.NonEmptyArray(effect_1.Schema.String)).annotations({
        description: 'At least one notification channel id. Every id must be a channel of the caller, otherwise the answer is 422 INVALID_NOTIFICATION_CHANNEL',
    }),
    scope: effect_1.Schema.optionalWith(notification_1.Scope, { exact: true }).annotations({
        description: 'Defaults to device. A request that passes validation with any other value is answered with 401: users can only manage device-scoped rules',
    }),
    deviceSerialNumbers: effect_1.Schema.optionalWith(effect_1.Schema.NonEmptyArray(effect_1.Schema.String), { exact: true }).annotations({
        description: 'Required for device scope and when scope is absent; forbidden for the other scopes. Every serial number must belong to a device owned by the caller, otherwise the answer is 422 INVALID_DEVICE',
    }),
    models: effect_1.Schema.optionalWith(effect_1.Schema.NonEmptyArray(effect_1.Schema.String), { exact: true }).annotations({
        description: 'Not usable by users: with no scope or any scope other than model the answer is 422, and model scope is answered with 401',
    }),
    tenantId: (0, field_1.optionalString)('Not usable by users: with device, model or all scope the answer is 422, tenant scope is answered with 401, and with no scope it is only stored on the rule'),
};
exports.NotificationCreatePayload = effect_1.Schema.Struct({
    ...rulePayload,
}).annotations({
    identifier: `${exports.NAMESPACE}.NotificationCreatePayload`,
    description: 'The owner is taken from the session, not from the body',
});
exports.NotificationUpdatePayload = effect_1.Schema.Struct({
    notificationId: (0, field_1.optionalString)('Notification id'),
    ruleId: (0, field_1.optionalString)('Alias copied to notificationId when notificationId is absent'),
    ...rulePayload,
}).annotations({
    identifier: `${exports.NAMESPACE}.NotificationUpdatePayload`,
});
exports.NotificationDeletePayload = effect_1.Schema.Struct({
    notificationId: (0, field_1.optionalString)('Notification id'),
    ruleId: (0, field_1.optionalString)('Alias copied to notificationId when notificationId is absent'),
}).annotations({
    identifier: `${exports.NAMESPACE}.NotificationDeletePayload`,
    description: 'One of notificationId and ruleId is required. After ruleId→notificationId aliasing, runtime validates only notificationId (not the full create/update rule schema)',
});
exports.Notification = effect_1.Schema.Struct({
    ...notification_fields_1.notificationKey,
    ...notification_fields_1.notificationBody,
}).annotations({
    identifier: `${exports.NAMESPACE}.Notification`,
    description: 'Notification rule of the signed-in user, with the stored id projected to notificationId and ruleId and without userId',
});
exports.NotificationList = effect_1.Schema.Struct({
    notifications: effect_1.Schema.Array(exports.Notification),
}).annotations({
    identifier: `${exports.NAMESPACE}.NotificationList`,
});
//# sourceMappingURL=schema.js.map